export default __webpack_public_path__ + "455ab9edeb83fdc050919e2d0b1ea791.svg";